import { render, staticRenderFns } from "./AssetsShoesDetails.vue?vue&type=template&id=27137d47&"
import script from "./AssetsShoesDetails.vue?vue&type=script&lang=js&"
export * from "./AssetsShoesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports